import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { getTermsDocument } from './termsDocuments';

// Documento completo dos termos. Quem renderiza decide o enquadramento: o
// cadastro do prestador abre no lugar do formulario e passa `backTo`, enquanto a
// rota /termos (usada pela WebView do app) abre sem nenhum caminho de volta,
// porque quem navega ali e o botao nativo do aplicativo.
function TermsPage({ title, audience, backTo }) {
  const terms = getTermsDocument(title, audience);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <main className="service-provider__content service-provider__terms-page">
      <article className="service-provider__terms-doc">
        <h1>{title}</h1>

        {terms ? (
          <React.Fragment>
            <p className="service-provider__terms-doc-meta">Última atualização: {terms.updatedAt}</p>

            {terms.sections.map(section => (
              <section className="service-provider__terms-doc-section" key={section.heading}>
                <h2>{section.heading}</h2>
                {section.paragraphs.map(paragraph => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                {section.items && (
                  <ul>
                    {section.items.map(item => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}

            <p className="service-provider__terms-doc-note">
            </p>
          </React.Fragment>
        ) : (
          <p>Este documento não está disponível.</p>
        )}
      </article>

      {backTo && (
        <div className="service-provider__terms-page-footer">
          <Link className="service-provider__button service-provider__button--secondary" to={backTo}>
            <ArrowBackIcon /> Voltar
          </Link>
        </div>
      )}
    </main>
  );
}

export default TermsPage;
